import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import Listings from "../components/Listings";
import HomeButton from "../components/HomeButton";
import { useTranslation } from "react-i18next";

export default function MyFavorites({ showHomeButton = true }) {
  const { user } = useAuth();
  const { t } = useTranslation();

  const [listingIds, setListingIds] = useState([]);

  useEffect(() => {
    const fetchFavorites = async () => {
      if (!user) return;

      try {
        const q = query(
          collection(db, "favorites"),
          where("userId", "==", user.uid)
        );

        const snap = await getDocs(q);

        const ids = snap.docs.map(doc => doc.data().listingId);
        setListingIds(ids);
      } catch (err) {
        console.error("Error fetching favorites:", err);
      }
    };

    fetchFavorites();
  }, [user]);

  if (!user) return <p>{t("auth.not_logged")}</p>;

  return (
    <div style={{ padding: 14 }}>
      
{showHomeButton && <HomeButton />}

<h1
  style={{
    fontSize: "22px",
    marginBottom: "14px",
  }}
>
  {t("profile.my_favorites")}
</h1>

      <Listings filter={{ ids: listingIds }} />
    </div>
  );
}
